import { platformBrowser } from '@angular/platform-browser';
import { AppModuleNgFactory } from '../compiled/app/app.module.ngfactory';
import { enableProdMode } from "@angular/core";

enableProdMode();
platformBrowser().bootstrapModuleFactory(AppModuleNgFactory);


// WEBPACK FOOTER //
// ./app/main.aot.ts